import { FC, memo, ReactElement } from 'react'

import './index.css'
import NonStaticParallax from './nonStaticParallax'
import StaticParallax from './staticParallax'
import { ParallaxProps } from './types'

const Parallax: FC<ParallaxProps> = (props): ReactElement => {
  const { imgData, classNames, isStatic, bgPosition, children } = props

  return isStatic ? (
    <StaticParallax imgData={imgData} bgPosition={bgPosition} classNames={classNames}>
      {children}
    </StaticParallax>
  ) : (
    <NonStaticParallax imgData={imgData} classNames={classNames}>
      {children}
    </NonStaticParallax>
  )
}
export default memo(Parallax)
